import Vue from 'vue'

// 判定依据：屏幕纵向 > 横向 视为手机端（竖屏），横向 > 纵向 视为电脑端
// 该对象是响应式的，窗口尺寸变化（含旋转屏幕）时会自动更新
export const screen = Vue.observable({
  portrait: false, // true = 手机端（竖屏）
  vw: 0,
  vh: 0,
})

function update() {
  const w = window.innerWidth || document.documentElement.clientWidth || 0
  const h = window.innerHeight || document.documentElement.clientHeight || 0
  screen.vw = w
  screen.vh = h
  screen.portrait = h > w
}

update()

if (typeof window !== 'undefined') {
  window.addEventListener('resize', update)
  window.addEventListener('orientationchange', update)
}

// 供各组件混入使用：this.isMobile / this.vw / this.vh
export const screenMixin = {
  computed: {
    isMobile() {
      return screen.portrait
    },
    vw() {
      return screen.vw
    },
    vh() {
      return screen.vh
    },
  },
}

export default screen
